import { ErrorsContextProvider } from 'components';
import { Modal, ModalActions, ModalContent, ModalHeader } from 'semantic-ui-react';
import { useUnlinkSpeakingSessionModal } from './useUnlinkSpeakingSessionModal';
import { useCallback } from 'react';
import { Button } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';

type Props = {
  modalOpen: boolean;
  speakingSessionId: number | undefined;
  lrwSessionId: number;
  closeModal: () => void;
};

export const UnlinkSpeakingSessionModal = ({
  modalOpen,
  speakingSessionId,
  lrwSessionId,
  closeModal,
}: Props) => {
  const { generalErrors, performUnlink, reset } = useUnlinkSpeakingSessionModal({
    closeModal,
    speakingSessionId,
    lrwSessionId,
  });

  const close = useCallback(() => {
    closeModal();
    reset();
  }, [reset, closeModal]);

  return (
    <S.Modal open={modalOpen} onClose={close} size="tiny" closeIcon closeOnEscape>
      <ErrorsContextProvider generalErrors={generalErrors}>
        <ModalHeader>Unlinking Speaking session</ModalHeader>
        <ModalContent>
          <div>Are you sure you want to unlink this Speaking session.</div>
        </ModalContent>
        <ModalActions>
          <Button compact type="reset" secondary onClick={close}>
            Cancel
          </Button>
          <Button compact primary color="red" onClick={performUnlink}>
            Unlink
          </Button>
        </ModalActions>
      </ErrorsContextProvider>
    </S.Modal>
  );
};

const S = {
  Modal: styled(Modal)`
    > .close.icon {
      color: black;
      right: 0;
      top: 0;
    }
  `,
};
